export default __webpack_public_path__ + "static/media/murrayhillboldregular.8e4bcca8.ttf";